// extracted by mini-css-extract-plugin
export var link = "partners-item-module--link--ZE8UX";
export var binaryStudio = "partners-item-module--binary-studio--dgRtc";